import { useSnapshot } from 'hooks/use-safe-snapshot';
import { savedItemsDerivedState } from 'state/current-saved-items';

const useCurrentSavedItems = () => {
    return useSnapshot(savedItemsDerivedState);
};

export { useCurrentSavedItems };
